import { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Loader from "./components/layout/Loader";

import LandingPage from "./pages/LandingPage";
import Destination from "./pages/Destination";
import DestinationDetail from "./pages/DestinationDetail";
import PackagesList from "./pages/PackagesList";
import PackageDetails from "./pages/PackageDetails";

import "./index.css";
import VisaServicePage from "./pages/VisaServicePage";
import VisaDestinationDetailPage from "./pages/VisaDestinationDetailPage";
import HelpandSupport from "./pages/HelpandSupportPage";
import AboutUs from "./pages/AboutUsPage";
import {
  detectVisitorRegion,
  dismissRegionSuggestion,
  getRegionalSiteUrl,
  resolveRegionSuggestion,
  type SupportedRegion,
} from "./utils/regionRedirect";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function App() {
  const isRootPath =
    typeof window !== "undefined" && window.location.pathname === "/";
  const [loading, setLoading] = useState(() => isRootPath);
  const [showRegionPopup, setShowRegionPopup] = useState(() => isRootPath);
  const [detectedRegion, setDetectedRegion] = useState<SupportedRegion | null>(
    null,
  );

  useEffect(() => {
    let isActive = true;

    detectVisitorRegion().then((region) => {
      if (!isActive) {
        return;
      }

      setDetectedRegion(region);
    });

    resolveRegionSuggestion().then((suggestion) => {
      if (!isActive || !suggestion) {
        return;
      }

      if (suggestion.mode === "redirect") {
        window.location.replace(suggestion.targetUrl);
      }
    });

    return () => {
      isActive = false;
    };
  }, [isRootPath]);

  useEffect(() => {
    if (!loading) return;

    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [loading]);

  const handleCloseRegionPopup = () => {
    if (detectedRegion) {
      dismissRegionSuggestion(detectedRegion);
    }

    setShowRegionPopup(false);
  };

  const handleGoToIndiaSite = () => {
    window.location.assign(getRegionalSiteUrl("IN"));
  };

  const handleGoToUaeSite = () => {
    window.location.assign(getRegionalSiteUrl("AE"));
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <ScrollToTop />
      <Header />

      <Routes>
        {/* Landing Page */}
        <Route
          path="/"
          element={
            <LandingPage
              detectedRegion={detectedRegion}
              showRegionPopup={showRegionPopup}
              onCloseRegionPopup={handleCloseRegionPopup}
              onGoToIndiaSite={handleGoToIndiaSite}
              onGoToUaeSite={handleGoToUaeSite}
            />
          }
        />

        {/* About Us */}
        <Route path="/about-us" element={<AboutUs />} />

        {/* Destination Hub */}
        <Route path="/destination" element={<Destination />} />

        {/* Packages */}
        <Route path="/packages" element={<PackagesList />} />
        <Route path="/packages/:id" element={<PackagesList />} />
        <Route path="/package-detail/:id" element={<PackageDetails />} />

         {/* Visa Services Hub */}
        <Route path="/visa-services" element={<VisaServicePage />} />
        <Route path="/visa-services/:slug" element={<VisaDestinationDetailPage />} />

       {/* Destination Detail*/}
        <Route path="/destination-detail" element={<DestinationDetail />} />
        <Route path="/destination-detail/:slug" element={<DestinationDetail />} /> 

        {/*HelpandSupport Hub */}
        <Route path="/help-and-support" element={<HelpandSupport />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
